import {mediaQueryBreakpointMD, updateQueryStringParam} from '../Utils/Utils';

const Newsroom = (domEl) => {

	let isLoading = false;
	let resetBeforeShowing = false;

	const timeline = domEl.querySelector('.timeline');
	const categoryFilters =  domEl.querySelectorAll('.category-filter .filter');
	const loadMoreButton = domEl.querySelector('.load-more-button');

	// Data Filters
	const posts_per_page = ( parseInt( domEl.getAttribute('data-posts_per_page')) > 0 ? parseInt(domEl.getAttribute('data-posts_per_page')) : 12 );
	let paged = ( parseInt( domEl.getAttribute('data-paged')) >= 0 ? parseInt(domEl.getAttribute('data-paged')) : 1 );
	const post_types = domEl.getAttribute('data-post_types');
	const post__not_in = domEl.getAttribute('data-post__not_in');
	const post__in = domEl.getAttribute('data-post__in');
	let offset = parseInt(domEl.getAttribute('data-offset'));
	const orderby = domEl.getAttribute('data-orderby');
	const order = domEl.getAttribute('data-order');
	let category = domEl.getAttribute('data-category');

	// Region filter
	const regionPostFilter = domEl.querySelector('.region-post-filter');
	const filterByRegionToggler = regionPostFilter.querySelector('.filter-by-region-toggler');
	const regionCheckboxes = regionPostFilter.querySelectorAll('input[type="checkbox"]');
	const regionAllCheckbox = domEl.querySelector('#region-all');

	const updateRegionUrlParams = () => {
		let searchParams = new URLSearchParams(window.location.search);
		let selectedRegions = [];

		regionCheckboxes.forEach((checkbox) => {
			if(checkbox.checked && checkbox.value !== 'all') {
				selectedRegions.push(checkbox.value);
			}
		});

		searchParams.set('region', selectedRegions.join(','));
		history.pushState(null, '', '?' + searchParams.toString());

		resetBeforeShowing = true;
		paged = 1;
		offset = 0;
		//isLoading = false;
		getBatch();
		renderFilters();
	};

	const toggleRegionPostFilter = (e) => {
		if(e) {
			e.preventDefault();
		}
		regionPostFilter.classList.toggle('js-active');
	};

	const handleCheckboxChange = (e) => {
		const isRegionAll = e.target.id === 'region-all';

		// If "region-all" is checked, uncheck and disable others
		if(isRegionAll) {
			regionCheckboxes.forEach((checkbox) => {
				if(checkbox.id !== 'region-all') {
					checkbox.checked = false;
				}
			});
			e.target.disabled = true;
		}
		else {
			// If any other checkbox is checked, uncheck "region-all"
			regionAllCheckbox.checked = false;
			regionAllCheckbox.disabled = false;

			// If all other checkboxes are unchecked, check and disable "region-all"
			const otherChecked = Array.from(regionCheckboxes).some((checkbox) => checkbox.id !== 'region-all' && checkbox.checked);
			if(!otherChecked) {
				regionAllCheckbox.checked = true;
				regionAllCheckbox.disabled = true;
			}
		}

		// Check if we are on desktop or mobile
		if(window.innerWidth >= mediaQueryBreakpointMD) {
			// For desktop, update the URL and get a new batch immediately
			updateRegionUrlParams();
		}
		else {
			// For mobile, just update the state without fetching new batch or updating URL
			// The actual batch fetch will happen when the 'Show' button is clicked
		}
	};

	// Event listener for toggling the filter
	filterByRegionToggler.addEventListener('click', toggleRegionPostFilter);

	// Add an event listener to your 'Show' button
	const filterSelectionButton = domEl.querySelector('.filter-selection-button button');
	filterSelectionButton.addEventListener('click', (e) => {
		if(window.innerWidth < mediaQueryBreakpointMD) {
			// For mobile, update URL and get a new batch when 'Show' button is clicked
			updateRegionUrlParams();

			// Close the filter selection
			regionPostFilter.classList.remove('js-active');
		}
	});

	// Event listener for outside click
	document.addEventListener('click', (e) => {
		if(!regionPostFilter.contains(e.target) && !filterByRegionToggler.contains(e.target) && regionPostFilter.classList.contains('js-active')) {
			regionPostFilter.classList.remove('js-active');
			resetRegionCheckboxes(); // Reset checkboxes when the filter selection is closed
		}
	});

	// Event listeners for checkbox changes
	regionCheckboxes.forEach((checkbox) => {
		checkbox.addEventListener('change', handleCheckboxChange);
	});

	// Function to reset the checkboxes based on the URL parameters or current filter state
	const resetRegionCheckboxes = () => {
		const searchParams = new URLSearchParams(window.location.search);
		const selectedRegions = searchParams.get('region') ? searchParams.get('region').split(',') : [];

		regionCheckboxes.forEach((checkbox) => {
			if (checkbox.value !== 'all') {
				checkbox.checked = selectedRegions.includes(checkbox.value);
			}
		});

		const isRegionAll = selectedRegions.length === 0 || selectedRegions.includes('all');
		regionAllCheckbox.checked = isRegionAll;
		regionAllCheckbox.disabled = isRegionAll;
	};

	//
	// Initialize
	loadMoreButton.addEventListener('click', (e) => {
		e.preventDefault();
		if(!isLoading) {
			getBatch();
		}
	});

	categoryFilters.forEach((filter) => {
		filter.addEventListener('click', (e) => {
			e.preventDefault();

			// Get the category slug
			const slug = filter.getAttribute('data-slug');
			if(slug !== category) {
				category = slug;

				// Update the history so we can go back and forth
				if(history.pushState) {
					// The current page number
					const uri = updateQueryStringParam('ctg', slug);
					window.history.pushState({path:uri},'',uri);
				}

				resetBeforeShowing = true;
				paged = 1;
				offset = 0;
				//isLoading = false;
				getBatch();
				renderFilters();
			}
		});
	});

	// Listen to changes in history when using back/forth buttons
	// Update the category and fetch data
	window.addEventListener('popstate', function (e) {
		const urlParams = new URLSearchParams(window.location.search);
		if(urlParams.get('ctg') !== category) {
			category = urlParams.get('ctg');
			resetBeforeShowing = true;
			paged = 1;
			offset = 0;
			//isLoading = false;
			getBatch();
			renderFilters();
		}
	});

	const renderFilters = () => {
		categoryFilters.forEach((filter) => {
			if(filter.getAttribute('data-slug') === category) {
				filter.classList.add('js-active');
			}
			else {
				filter.classList.remove('js-active');
			}
		});
	};

	const getBatch = () => {

		if(isLoading) {
			return false;
		}

		// Prepare to get a new batch
		domEl.classList.add('js-loading');
		isLoading = true;

		const formData = new FormData();
		formData.append('action', SVITZER21_Localize.action.getBatchPosts);
		formData.append('nonce', SVITZER21_Localize.nonce.getBatchPosts);
		formData.append('paged', paged);
		formData.append('offset', offset);
		formData.append('posts_per_page', posts_per_page);
		formData.append('post_types', post_types);
		if(post__not_in) {
			formData.append('post__not_in', post__not_in);
		}
		if(post__in) {
			formData.append('post__in', post__in);
		}
		formData.append('orderby', orderby);
		formData.append('order', order);
		if(category) {
			formData.append('category', category);
		}
		const searchParams = new URLSearchParams(window.location.search);
		if(searchParams.get('region')) {
			formData.append('region', searchParams.get('region'))
		}

		const header = new Headers({
			'Accept': 'application/json',
			'Content-Type': 'application/json',
		});
		fetch(SVITZER21_Localize.ajaxUrl, {
			method		: 'POST',
			mode		: 'cors',
			header		: header,
			body		: formData,
			credentials	: 'same-origin',
			cache		: 'no-store',
		})
			.then((response) => {
				if(response.status >= 200 && response.status < 300) return Promise.resolve(response);
				else return Promise.reject(new Error(response.statusText));
			})
			.then((response) => {
				return response.json();
			})
			.then( onBatchFetched )
			.catch((ex) => {
				console.log('Newsroom > parsing failed', ex);
				isLoading = false;
			});
	};

	const onBatchFetched = (response) => {

		if(response.success) {

			// Update the history so we can go back and forth
			if(history.pushState) {
				const uri = updateQueryStringParam('pg', paged); // The current page number
				window.history.pushState({path:uri},'',uri);
			}

			// Alter the timeline
			if(response.data.post_count <= 0 && paged === 1) {
				timeline.innerHTML = '';
				hideLoadMoreBtn();
			}
			else if(response.data.post_count > 0) {

				//$_no_results.style.display = 'none';

				// Append the posts to the timeline
				if(resetBeforeShowing) {
					timeline.innerHTML = '';
				}

				timeline.insertAdjacentHTML('beforeend', response.data.posts );

				// Manage the load more button
				if(response.data.found_posts > 0) {
					if((paged * posts_per_page) >= response.data.found_posts || (offset + posts_per_page) >= response.data.found_posts) {
						hideLoadMoreBtn();
					}
					else {
						showLoadMoreBtn();
					}
				}

				// Per default - the single post-post instances are hidden and only revealed via IntersectionObserverAnimation
				// We replicate that functionality
				domEl.querySelectorAll('.post-post:not(.in-view)').forEach(el => observer.observe(el));

				// Prepare next
				paged++;
				offset += posts_per_page;
			}
			else
			{
				// No more posts to append
				if(loadMoreButton.length > 0) {
					hideLoadMoreBtn();
				}
			}
			resetBeforeShowing	= false;
		}

		// Re-enable load
		isLoading = false;
		domEl.classList.remove('js-loading');
	};

	let observer = new IntersectionObserver((entries, observer) => {
		entries.forEach(entry => {
			if(entry.intersectionRatio !== 0) {
				entry.target.classList.add('in-view');
				observer.unobserve(entry.target);
			}
		});
	},
	{rootMargin: "0px 0px 0px 0px"});

	const hideLoadMoreBtn = () => {
		if(loadMoreButton) {
			loadMoreButton.style.display = 'none';
		}
	};
	const showLoadMoreBtn = () => {
		if(loadMoreButton) {
			loadMoreButton.style.display = 'flex';
		}
	};
};

export default Newsroom;